import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../types/api-response";
import axios from "../../utils/axiosInceptor";
import { apiV1Endpoint } from "./endpoints";

type UnitTypeMap = Record<string, string[]>;

export type PropertyType = {
  usagesType: string;
  unitType: UnitTypeMap;
  isDeleted: boolean;
  status: string;
  createdAt: string;
  updatedAt: string;
};

type UseGetPropertyTypesOptions = {
  isEnabled?: boolean;
};

const getPropertyTypes = async () => {
  const url = `${apiV1Endpoint}/property/propertyTypes`;
  const response = await axios.get<ApiResponse<PropertyType[]>>(url);
  return response.data.result;
};

export const useGetPropertyTypes = (options: UseGetPropertyTypesOptions = {}) => {
  const { isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["property-types"],
    queryFn: getPropertyTypes,
    enabled: isEnabled,
  });

  return {
    propertyTypes: data ?? [],
    isLoadingPropertyTypes: isLoading,
  };
};
